
document.addEventListener("DOMContentLoaded", function () {
  const customFilters = document.querySelectorAll(".js-custom-term");
  const productListWrapper = document.querySelector(".productgrid--wrapper");

  // --- Extract tag filters from URL ---
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const selectedTagsFromUrl =
    pathParts.length > 2 ? pathParts[2].split("+") : [];

  const selectedNormalized = selectedTagsFromUrl.map((c) =>
    c.toLowerCase().replace(/\s+/g, "-")
  );

  // --- Highlight active filters ---
  customFilters.forEach((li) => {
    const val = li.getAttribute("data-filter")?.toLowerCase().replace(/\s+/g, "-");

    if (selectedNormalized.includes(val)) {
      li.classList.add("collection-filters__filter-list-item--active");
    }
  });

  // --- Tag click → update URL only ---
  document.querySelectorAll(".js-custom-term").forEach((filterEl) => {
    filterEl.addEventListener("click", function (e) {
      e.preventDefault();

      const filterValue = this.getAttribute("data-filter") || "";

      // Handle complex labels like "Black & White"
      const tagParts = filterValue
        .split("&")
        .map((t) => t.trim().toLowerCase().replace(/\s+/g, "-"))
        .filter(Boolean);

      // Extract base collection handle
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      const collectionsIndex = pathParts.indexOf("collections");
      const collectionHandle = pathParts[collectionsIndex + 1] || "";

      // Smooth scroll flag
      sessionStorage.setItem("scrollToProducts", "true");

      // Build Shopify tag URL (this reloads the page)
      const newUrl = `/collections/${collectionHandle}/${tagParts.join("+")}`;
      window.location.href = newUrl;
    });
  });

  // --- Smooth scroll after reload ---
  if (sessionStorage.getItem("scrollToProducts") === "true") {
    sessionStorage.removeItem("scrollToProducts");

    setTimeout(() => {
      productListWrapper?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 600);
  }
});